import { LanguageType } from "@/custom-types";
import {
  NotificationTypeOption,
  MessageCreatedNotificationData,
  ContractNotificationData,
} from "@/graphql/generated";

type NotificationMessageMapperParams = {
  type: NotificationTypeOption;
  message: string;
  language: LanguageType;
  translatedTexts: {
    newChatMessage: string;
    newChatMessageFrom: string;
    rentChargePaid: string;
    paymentDeadlineNotification: string;
    incidentCreated: string;
    incidentReportSubmitted: string;
    incidentFollowUp: string;
    incidentAssigned: string;
    contractStarted: string;
    contractExpired: string;
    contractExpirationSoon: string;
     incidentResponsibilityRequired: string;
  };
  messageData?: MessageCreatedNotificationData | null;
  contractData?: ContractNotificationData | null;
};

export const notificationMessageMapper = ({
  type,
  message,
  translatedTexts,
  messageData,
  contractData,
}: NotificationMessageMapperParams): string => {
  if (type === NotificationTypeOption.NewChatMessage) {
    if (messageData?.senderName) {
      return translatedTexts.newChatMessageFrom.replace('{sender}', messageData.senderName);
    }
    return translatedTexts.newChatMessage;
  }

  if (type === NotificationTypeOption.RentChargePaid) {
    return translatedTexts.rentChargePaid;
  }

  if (type === NotificationTypeOption.PaymentDeadlineNotification) {
    return translatedTexts.paymentDeadlineNotification;
  }

  if (type === NotificationTypeOption.IncidentCreated) {
    return translatedTexts.incidentCreated;
  }

  if (type === NotificationTypeOption.IncidentReportSubmitted) {
    return translatedTexts.incidentReportSubmitted;
  }

  if (type === NotificationTypeOption.IncidentFollowUp) {
    return translatedTexts.incidentFollowUp;
  }

  if (type === NotificationTypeOption.IncidentAssigned) {
    return translatedTexts.incidentAssigned;
  }

  if (type === NotificationTypeOption.IncidentResponsibilityRequired) {
    return translatedTexts.incidentResponsibilityRequired;
  }

  if (type === NotificationTypeOption.ContractStarted) {
    if (contractData?.tenantName && contractData?.propertyName) {
      return translatedTexts.contractStarted
        .replace('{tenant}', contractData.tenantName)
        .replace('{property}', contractData.propertyName);
    }
    return translatedTexts.contractStarted;
  }

  if (type === NotificationTypeOption.ContractExpired) {
    if (contractData?.tenantName && contractData?.propertyName) {
      return translatedTexts.contractExpired
        .replace('{tenant}', contractData.tenantName)
        .replace('{property}', contractData.propertyName);
    }
    return translatedTexts.contractExpired;
  }

  if (type === NotificationTypeOption.ContractExpirationSoon) {
    if (contractData?.tenantName && contractData?.propertyName) {
      return translatedTexts.contractExpirationSoon
        .replace('{tenant}', contractData.tenantName)
        .replace('{property}', contractData.propertyName);
    }
    return translatedTexts.contractExpirationSoon;
  }
  
  return message;
};

